(function() {})
const DEBUG = true // Passer à false pour stoper les console.log() de débug.

/* va calculer les dimensions de la fenetre (largeur/hauteur/ratioPixel)__:
 * les variables seront accessibles par les autres fct
--------------------------------------------------------------------------------*/
const DOC_ELEM = document.documentElement
var W_WIDTH, W_HEIGHT, W_PIXEL_RATIO, H_DOC, W_DOC, SCROLL_Y //Variables globales

function dimensionsFenetre(){
	W_WIDTH = DOC_ELEM.clientWidth || window.innerWidth 
	W_HEIGHT = DOC_ELEM.clientHeight || window.innerHeight 
	W_PIXEL_RATIO = window.devicePixelRatio;
	H_DOC = document.body.clientHeight //Calcule la hauteur de la page entière
	W_DOC = document.body.clientWidth //Calcule la hauteur de la page entière
	// SCROLL_Y = window.pageYOffset || DOC_ELEM.scrollTop //Indique en pixel de combien est le scroll
	setPosScrollY();
	if (DEBUG) console.log('Fenetre dimensions : '+W_WIDTH+'px, '+'W_HEIGHT : '+W_HEIGHT+', pixelratio : '+W_PIXEL_RATIO+'. Hauteur totale doc : '+H_DOC+', largeur totale doc : '+W_DOC+', Scroll :'+SCROLL_Y+', ')
	return true
}

// Retourne et assigne la valeur du scroll Y
function setPosScrollY(){
	SCROLL_Y = window.pageYOffset || DOC_ELEM.scrollTop //on met a jour la variable globale du scrool
}

// http://stackoverflow.com/a/5598797/989439
function getOffset( el ) {
	let offsetTop = 0, offsetLeft = 0
	do {
		if ( !isNaN( el.offsetTop ) ) {
			offsetTop += el.offsetTop;
		}
		if ( !isNaN( el.offsetLeft ) ) {
			offsetLeft += el.offsetLeft;
		}
	} while( el = el.offsetParent )

	return {
		top : offsetTop,
		left : offsetLeft
	}
}

//Permet de determiner si un elemetn est dans le viewport
function inViewport( el, h ) {
	let elH = el.offsetHeight
	let scrolled = SCROLL_Y
	let viewed = scrolled + W_HEIGHT
	let elTop = getOffset(el).top
	let elBottom = elTop + elH

	// if 0, the element is considered in the viewport as soon as it enters.
	// if 1, the element is considered in the viewport only when it's fully inside
	// value in percentage (1 >= h >= 0)
	h = h || 0

	return (elTop + elH * h) <= viewed && (elBottom - elH* h) >= scrolled
}

/* 
 *
 * INITS GENERAUX__:
 *
 */

// Detect JS support
document.body.className = document.body.className + " js_enabled";

//>Calcul de la taille disponible (de la fenetre), Cette fct utilise des variables globales
dimensionsFenetre();
//on rapelle la fct plus tard si des elements n'ont pas eu le temps de charger (images,...)
setTimeout(function(){
	dimensionsFenetre();
}, 1200);

//>Va a chaque resize appeler une fct
(function() {
	var throttle = function(type, name, obj) {
		obj = obj || window
		var running = false
		var func = function() {
			if (running) { return }
			running = true;
			 requestAnimationFrame(function() {
				obj.dispatchEvent(new CustomEvent(name))
				running = false;
			})
		}
		obj.addEventListener(type, func)
	}

	/* init - you can init any event */
	throttle("resize", "optimizedResize")
})()

// handle event
window.addEventListener("optimizedResize", () => {
	dimensionsFenetre(); // Raffraichi les variables
})

//>Va a chaque scroll appeler une fct.
var tickingScroll = false
window.addEventListener('scroll', function() {
	if (!tickingScroll) {
		window.requestAnimationFrame(function() {
			setPosScrollY(); // Rafraichi la valeur de la variable qui mémorise la position du scroll
			tickingScroll = false
			// Ci-dessous inscrire les autres fonctions qui ont besoin des être appelé
			headerMainCheckCompact();
		})
	}
	tickingScroll = true
})

/* 
 *
 * Autres fonctions__:
 *
 */


// Determine si il faut que le menu principal soit compacté
let menuMain = document.querySelector('#masthead')
function headerMainCheckCompact(){
	console.log('headerMainCheckCompact')
	if (SCROLL_Y <= 0) {
		menuMain.classList.remove('is-compact')
		return true
	}

	let delta = (W_HEIGHT / 3)
	if (SCROLL_Y > delta) {
		menuMain.classList.add('is-compact')
	}
}



/*
 * Permet de gener les animations de animatedss en JS
 * element : string ou objet
 * animationName : Array des classes à ajouter
 * callback : à executer
*/
function animateCSS(element, animationName, callback) {
	const node = (typeof element === 'object') ? element : document.querySelector(element) // Si c'est un objet on ne recherche pas l'élément ds la page
	console.log('node')
	console.log(node)
	node.classList.add('animated', ...animationName)

	function handleAnimationEnd() {
		node.classList.remove('animated', ...animationName)
		node.removeEventListener('animationend', handleAnimationEnd)

		if (typeof callback === 'function') callback()
	}

	node.addEventListener('animationend', handleAnimationEnd)
}

// Exemple d'utilisation de la fct animateCSS
/*$('.vadMainNavbar .dropdown').on('show.bs.dropdown', function() {
	let menu = $(this).find('.dropdown-menu > ul')[0]
	// console.log('S H O W')
	// console.log($(this))
	// console.log(menu)
	animateCSS(menu, ['slideInDown'], () => {
		// Do something after animation
	})
})

$('.vadMainNavbar .dropdown').on('hide.bs.dropdown', function() {
	let menu = $(this).find('.dropdown-menu > ul')[0]
	// console.log('H I D E')
	// console.log($(this))
	// console.log(menu)
	$(this).find('.dropdown-menu ')[0].classList.add('animated', 'fast')
	animateCSS(menu, ['slideOutUp', 'fast'], () => {
		// Do something after animation
		$(this).find('.dropdown-menu ')[0].classList.remove('animated', 'fast')
	})
})//*/